module.exports = __webpack_public_path__ + "images/20f4e9cf79d47a7639e876d1fa65dc015.svg";